import { useKeyboardShortcutAudioControl } from "./useKeyboardShortcutAudioControl";
import { THEME_DARK, THEME_LIGHT } from "@/theme/theme.ts";
import useThemeMode from "@/common/hooks/useThemeMode.ts";
import useKeyboardListener from "@/common/hooks/useKeyboardListener";
import { ModalTypes } from "@/enum/modalTypes.ts";
import { useCallback } from "react";

export const useKeyboardShortcutToggleThemeMode = () => {
  const [themeMode, setThemeMode] = useThemeMode();

  const allowedModalTypes = [
    ModalTypes.TRACK_VIEW
  ];

  const { withShortcutCheck } = useKeyboardShortcutAudioControl({
    allowedModalTypes,
  });

  const toggleThemeMode = useCallback(() => {
    const mode = themeMode === THEME_DARK ? THEME_LIGHT : THEME_DARK;
    setThemeMode(mode);
  }, [
    themeMode,
    setThemeMode
  ]);

  useKeyboardListener(
    withShortcutCheck((event) => {
      if (event.key === "T" && event.shiftKey) {
        event.preventDefault();
        toggleThemeMode();
      }
    })
  );

  return null;
};
